import React, {  useEffect,useState } from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import 'bootstrap/dist/css/bootstrap.min.css';
import './Assets/Css/home.css'

import { FaWhatsapp } from "react-icons/fa";
import { FaAnglesUp } from "react-icons/fa6";


import ScrollToTop from './Webpages/ScrollToTop'

import WebHeader from './Components/WebHeader'
import WebFooter from './Components/WebFooter'
import HomePage from './Webpages/HomePage'
import About from './Webpages/About';
import Contact from './Webpages/Contact';
import Services from './Webpages/Services';


import AOS from 'aos';
import 'aos/dist/aos.css';

import CleaningServices from './Webpages/CleaningServices';
import MaintenanceServices from './Webpages/MaintenanceServices';
import CivilConstructionServices from './Webpages/CivilConstructionServices';
import PaintingCoatingServices from './Webpages/PaintingCoatingServices';
import PestBirdControl from './Webpages/PestBirdControl';
import ManpowerandHousekeeping from './Webpages/ManpowerandHousekeeping';
import FabricationServices from './Webpages/FabricationServices';
import MepService from './Webpages/MepService';









// Pages
const App = () => {

   useEffect(() => {
        AOS.init({ duration: 1000 });
      }, []);

  const [showScroll, setShowScroll] = useState(false);

  useEffect(() => {
    const checkScroll = () => {
      if (window.scrollY > window.innerHeight / 2) {
        setShowScroll(true);
      } else {
        setShowScroll(false);
      }
    };

    window.addEventListener("scroll", checkScroll);
    return () => window.removeEventListener("scroll", checkScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

 

  return (
    <BrowserRouter>
      
        <WebHeader/>
        <div>
          <ScrollToTop/>
        <Routes>

          <Route path="*" name="HomePage" element={<HomePage />} />
          <Route path="/" name="HomePage" element={<HomePage/>} />
          <Route path="/aboutus" name="About" element={<About/>} />
       <Route path="/cleaningservices" name=" Cleaning Services" element={<CleaningServices/>} />
        <Route path="/maintenanceservice" name=" Maintenance Services" element={<MaintenanceServices/>} />
         <Route path="/civilconstructionser" name="Civil & Construction Services" element={<CivilConstructionServices/>} />
         <Route path="/mepservice" name=" Mechanical, Electrical & Plumbing (MEP)" element={<MepService/>} />
          <Route path="/paintingandcoating" name=" Painting & Coating" element={<PaintingCoatingServices/>} />
           <Route path="/pestbirdcontrol" name="Pest & Bird Control" element={<PestBirdControl/>} />
            <Route path="/manpowerandhousekeeping" name=" Manpower & Housekeeping" element={<ManpowerandHousekeeping/>} />
           <Route path="/fabricationservices" name=" Fabrication Services" element={<FabricationServices/>} />
           
           
         <Route path="/contact" name="Contact" element={<Contact/>} />
         
         
          
        </Routes>
       
           <a
      href="https://wa.me/8482922662" 
        className="whatsapp-icon"
      target="_blank"
      rel="noopener noreferrer"
      title="Chat with us!"
    >
          <FaWhatsapp />
        </a>
        

{showScroll && (
  <button className="scroll-to-top show" onClick={scrollToTop}>
   <FaAnglesUp />
  </button>
)}


        </div>
     <WebFooter/>
      
    </BrowserRouter>
  )
}

export default App
